import { render } from "./AppComponentLoader.vue?vue&type=template&id=43bf58ec"
import script from "./AppComponentLoader.vue?vue&type=script&lang=js"
export * from "./AppComponentLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__